export default __webpack_public_path__ + "static/media/04.3b92e4a9.jpg";